<template>
    <Dropdown
        :disable="!showDropdown"
        dropdown-position="left"
        class="RPNavigation"
    >
        <template v-slot="{toggleDropdown, open}">
            <div class="RPNavigation__container">
                <button
                    class="RPNavigation__title"
                    @click="titleAction(toggleDropdown)"
                >
                    <StreamlineIcon
                        class="RPNavigation__title-icon"
                        :icon="pageIcon"
                        :stroke="grey200"
                        :size="24"
                    />
                    <h5 class="RPNavigation__title-text">
                        {{ activeSection.label }}
                    </h5>
                    <StreamlineIcon
                        v-if="showDropdown"
                        class="RPNavigation__title-arrow"
                        :icon="open ? ArrowDown1 : ArrowUp1"
                        :stroke="grey"
                        :size="14"
                    />
                </button>
                <template v-if="!showDropdown">
                    <RPNavTab
                        v-for="subsection in subsections"
                        :key="subsection.key"
                        class="RPNavigation__link"
                        :to="subsection.to"
                        :active-tab="activeSubsection.to.name"
                        @navigate="to => $emit('navigate', to)"
                    >
                        {{ subsection.label }}
                    </RPNavTab>
                </template>
            </div>
        </template>
        <template v-slot:dropdown="{close}">
            <div class="RPNavigation__dropdown">
                <RPNavTab
                    v-for="subsection in subsections"
                    :key="subsection.key"
                    class="RPNavigation__link--dropdown"
                    :to="subsection.to"
                    :active-tab="activeSubsection.to.name"
                    @navigate="to => nav(to, close)"
                >
                    {{ subsection.label }}
                </RPNavTab>
            </div>
        </template>
    </Dropdown>
</template>

<script>
import navIconHelper from '../../navIconHelper';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import RPNavTab from 'components/Basic/Buttons/RPNavTab.vue';
import Dropdown from 'components/Basic/Elements/Dropdown.vue';
import {ArrowUp1, ArrowDown1} from "@reviewpush/streamline-regular/lib/arrows-diagrams/Arrows";
import {grey200, grey}  from 'style/_colors.scss';

export default {
    name: "RPNavigation",
    components: {
        StreamlineIcon,
        RPNavTab,
        Dropdown,
    },
    props: {
        activeSection: {
            type: Object,
            required: true,
        },
        subsections: {
            type: Array,
            required: true,
        },
        /**
         * See `RPDashboardLayout` for prop details
         */
        activeSubsection: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            size: 1000,
            ArrowUp1,
            ArrowDown1,
            grey200,
            grey
        };
    },
    computed: {
        showDropdown(){
            return this.size < 1000 && this.subsections.length > 0;
        },
        pageIcon(){
            return navIconHelper(this.activeSection.icon);
        },
    },
    destroyed(){
        document.removeEventListener('resize', this.resize);
    },
    mounted() {
        window.addEventListener('resize', this.resize);
        this.resize();
    },
    methods: {
        resize(){
            this.size = Math.min(window.innerWidth, window.screen.width);
        },
        titleAction(toggle){
            if(this.showDropdown){
                toggle();
            } else {
                window.location.reload();
            }
        },
        nav(to, closeDropdown){
            this.$emit('navigate', to);
            closeDropdown();
        }
    }
};
</script>

<style lang="scss">
.RPNavigation {
    height: 100%;

    &__container{
        height: 100%;
        display: flex;
        align-items: center;
    }
    &__title {
        display: flex;
        align-items: center;
        padding-right: 1rem;
        &-icon {
            margin: 0 1rem;
        }
        &-text {
            font-weight: 600;
            color: $grey-500;
            margin-right: 0.5rem;
        }
    }
    &__link {
        margin-right: 0.5rem;
        &--dropdown{
            margin-bottom:1rem;
        }
    }
    &__dropdown{
        border: 1px solid $grey-100;
        border-radius: 4px;
        padding: 1rem 1rem 0 1rem;
        background: $white;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>